export const SECTION_ITEMS_MOVIES_POPULAR_ACTION =
  'SECTION_ITEMS_MOVIES_POPULAR_ACTION';
export const SECTION_ITEMS_MOVIES_POPULAR_SUCCESS_ACTION =
  'SECTION_ITEMS_MOVIES_POPULAR_SUCCESS_ACTION';
export const SECTION_ITEMS_MOVIES_POPULAR_FAILURE_ACTION =
  'SECTION_ITEMS_MOVIES_POPULAR_FAILURE_ACTION';
